import TileManager from './TileManager';

export default TileManager;
